<template>
    <div v-show="is_case_mode"
        id="pane-tag-case" 
        class="pane-tag-case"
    >
        {{ case_name }}
    </div>
</template>

<script>
    import { mapState, mapGetters } from 'vuex';

    export default {
        name: 'PaneTagCase',

        computed: {
            ...mapState('case', [
                'case_selected'
            ]), 
            
            ...mapGetters('case', [
                'is_case_mode'
            ]),

            case_name() {
                return this.case_selected.case_name
            }
        },
    }
</script>

<style scoped>
    .pane-tag-case {
        position: relative;
        top: .15rem;
        display: block;
        margin: 0 3.35rem 0 .35rem;
        padding: 0 .2rem;
        height: 1.8rem;
        font-size: 1rem;
        line-height: 1.8rem;
        color: #fff;
        background-color: var(--base-gray);
        border-radius: 5px;
        box-shadow: 0 0 0 1.5px var(--aqua-active);
        cursor: default;
    }
</style>


